<template>
  <div class="order-list">
    <ul
      class="order-content"
      v-if="!loading && orderList.length"
    >
      <li
        class="order-info-box"
        v-for="(item, index) in orderList"
        :key="index"
      >
        <div class="header">
          <span class="time-box">
            <i class="icon"></i>
            <span class="time">{{ item.createTime }}</span>
          </span>
          <span
            class="state"
            :class="item.statusCode"
          >{{ item.statusName }}</span>
        </div>
        <div
          class="info-box"
          @click="go(item)"
        >
          <div class="img-box">
            <img
              class="img"
              v-lazy="imgRoot+item.picUrls"
            />
          </div>
          <div class="info">
            <p class="name-money">
              <span class="name">{{ item.productName }}</span>
              <span class="money">￥{{ item.proPrice.toFixed(2) }}</span>
            </p>
            <p class="attrs-num">
              <span class="attrs">{{ item.businessType == '4' ? item.attrValues : item.reSkuName || item.skuName }}</span>
              <span class="num-box">&times;{{ item.num }}</span>
            </p>
            <!-- <p class="name-money">
              <span class="name">{{ item.productName }}</span>
              <span class="money">￥{{ item.salePrice }}</span>
            </p>
            <p class="attrs-num">
              <span class="attrs">{{ item.businessType == '4' ? item.attrValues : item.skuName }}</span>
              <span class="num-box">&times;{{ item.num }}</span>
            </p> -->
          </div>
        </div>
        <div class="desc">
          共{{ item.num }}件商品  总额：￥{{ item.reSkuId ? item.reDealPrice : item.dealPrice }}
          <!-- 共{{ item.num }}件商品  总额：￥{{ item.dealPrice }} -->
        </div>
        <div
          class="btn-row-content"
          v-if="!hideTwoPay"
        >
          <order-button
            :status-code="item.statusCode"
            :index="index"
            :order-no="item.orderNo"
            :exp-no="item.expNo"
            :exp-comp-name="item.expCompName"
            @setOrderActionInfo="setOrderActionInfo"
          />
        </div>
      </li>
    </ul>
    <order-action
      :types="orderActionType"
      :order-deatil="orderDeatil"
      @cancel="setOrderActionInfo"
      @confirmDelOrder="firstList"
      @confirmCancelOrder="firstList"
    />
    <error-panel
      :type="type"
      v-if="!loading && !orderList.length"
    />
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import {setSessionCache, getCacheUserInfo, removeStorageInfo} from '../utils/'
  import config from '../config/'
  import {Api} from '../api/'
  import orderAction from '../components/orderAction'
  import orderButton from '../components/orderButton'

  export default {
    name: 'History',
    computed: {
      ...mapGetters({
        user: 'user',
        orderList: 'orderList'
      })
    },
    data() {
      return {
        loading: true,
        recordCount: 0, // 总数据条数
        offset: 0, // 当前
        pageSize: 30,
        isNo: true, // 是否可以加载
        type: '', // 错误类型
        imgRoot: '',
        orderActionType: '' // 二次确认弹窗类型 取消订单 删除订单
        , orderDeatil: {} // 订单详情
        , hideTwoPay: config.hideTwoPay // 隐藏二次支付
      }
    },
    created() {
      
      this.imgRoot = Api.imgRoot
      this.$store.dispatch('getEnv').then(() => {
        this.$store.dispatch('appInfoInitialize')
          .then(() => {
            this.updateUserInfo() // 获取缓存的用户信息
            this.firstList()
          })
      })
    },
    mounted() {
      window.addEventListener('scroll', this.scroll, true)
      
    },
    methods: {
      updateUserInfo() {
        let cacheUser = getCacheUserInfo()
        if (cacheUser) {
          this.$store.dispatch('updateUserInfo', {data: cacheUser})
        }
      },
      firstList() {
        this.offset = 0
        this.pageSize = 30
        this.$store.dispatch('clearOrderList')
        this.getOrderList()
      },
      scroll() {
        if (this.offset < this.recordCount) { // 未加载完毕才执行
          let scrollTop, bodyScrollTop, documentScrollTop
          scrollTop = 0
          bodyScrollTop = 0
          documentScrollTop = 0
          if (document.body) {
            bodyScrollTop = document.body.scrollTop
          }
          if (document.documentElement) {
            documentScrollTop = document.documentElement.scrollTop
          }
          scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop
          // 文档的总高度
          let scrollHeight, bodyScrollHeight, documentScrollHeight
          scrollHeight = 0
          bodyScrollHeight = 0
          documentScrollHeight = 0
          if (document.body) {
            bodyScrollHeight = document.body.scrollHeight
          }
          if (document.documentElement) {
            documentScrollHeight = document.documentElement.scrollHeight
          }
          scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight
          // 浏览器视口的高度
          let windowHeight = 0
          if (document.compatMode === 'CSS1Compat') {
            windowHeight = document.documentElement.clientHeight
          } else {
            windowHeight = document.body.clientHeight
          }
          if (scrollTop + windowHeight === scrollHeight) {
            this.getOrderList()
          }
        }
      },
      getOrderList() {
        if (!this.user.token) {
          this.$router.replace({name: 'index'})
        }
        this.$spinner.open('正在加载数据...')
        if (this.isNo) {
          this.isNo = false // 不可以滚动加载
          this.$store.dispatch('getOrderRecord', {
            offset: this.offset,
            pageSize: this.pageSize
          })
            .then(({datas, recordCount}) => {
              if (datas.length === 0) {
                this.type = 'noOrder'
              } else {
                this.offset += this.pageSize
                this.recordCount = recordCount
              }
              
            })
            .catch(() => {
              this.$store.dispatch('clearOrderList')
              this.type = 'serverError'
            })
            .finally(() => {
              this.$spinner.close()
              this.loading = false
              this.isNo = true // 可以加载
            })
        }
      },
      go(order) {
        setSessionCache('tradeId', order.tradeId)
        this.$router.push({ name: 'detail', query: { orderId: order.orderId, tradeId: order.tradeId } })
        // this.$router.push({name: 'detail', query: {tradeId: order.tradeId}})
      },
      setOrderActionInfo({type, index}) {
        this.orderActionType = type
        this.orderDeatil = this.orderList[index]
      }
    },
    components: {
      orderButton
      , orderAction
    },
    destroyed() {
      // 移除滚动加载事件
      window.removeEventListener('scroll', this.scroll, true)
      removeStorageInfo('senPay')
      window.sessionStorage.removeItem('wxPayInfo')
      window.sessionStorage.removeItem('wxPayInfoTime')
    }
  }
</script>

<style scoped lang="scss">
  @import "../assets/common.scss";

  .order-list {
    @extend %container;
    .order-content {
      @extend %content;
      background-color: #f1f1f1;
      .order-info-box {
        padding: 32px 0px 32px 0px;
        background-color: #ffffff;
        border-radius: 12px;
        margin-bottom: 21px;
        .header {
          color: #666666;
          padding: 0 35px;
          @extend %flex-between-center;
          .time-box {
            @extend %flex-center-row;
            .icon {
              width: 36px;
              height: 33px;
              display: block;
              background: url("../assets/image/icon-time.png") no-repeat;
              background-size: cover;
              margin-right: 22px;
            }
            .time {
              font-size: 33px;
            }
          }
          .state {
            font-size: 36px;
            &.TO_BE_PAY {
              color: #ff0000;
            }
            &.FINISH {
              color: #00c35b;
            }
          }
        }

        .info-box {
          @extend %flex-center-row;
          padding: 30px 35px 0 16px;
          .img-box {
            width: 215px;
            flex: 0 0 auto;
            @extend %flex-center-center;
            font-size: 0;
            .img {
              width: 170px;
            }
          }
          .info {
            padding-left: 15px;
            width: 100%;
            .name-money {
              font-size: 42px;
              color: #000000;
              padding-bottom: 5px;
              @extend %flex-row;
              justify-content: space-between;
              .money {
                font-size: 36px;
                flex: 0 0 auto;
                padding-left: 120px;
              }
            }
            .attrs-num {
              color: #999999;
              font-size: 36px;
              @extend %flex-row;
              justify-content: space-between;
              // align-items: center;
              .num-box {
                flex: 0 0 auto;
                padding-left: 120px;
              }
            }
          }
        }
        .desc {
          color: #000000;
          font-size: 36px;
          @extend %flex-center;
          justify-content: flex-end;
          padding: 5px 35px 25px;
        }
        .btn-row-content {
          padding: 0 35px;
        }
      }
    }
    .no-order {
      text-align: center;
      .icon {
        width: 210px;
        height: 210px;
        margin-top: 400px;
        display: inline-block;
        background: url('../assets/image/noOrderData.png') no-repeat;
        background-size: 210px;
      }
      p {
        font-size: 45px;
        margin-top: 40px;
      }
    }
  }
</style>
